
import { useEffect } from 'react'
import { useAppSelector } from 'store/hooks'
import { writeDataLayer } from 'utils/helpers'

export const HomePage: React.FC = () => {
  const authState = useAppSelector((state) => state.auth)

  useEffect(() => {
    writeDataLayer('home', authState)
  }, [])

  


  return (
    <group data-height="auto" data-min-height="fit">

      <group data-background="main-background" data-length="280" >

        
        <group>
        

        </group>

      </group>

    </group>
  )
}
